import doc                                 from '@widesk-core/decorators/doc';
import AbstractContentToPublishStatusModel from './AbstractContentToPublishStatusModel';

@doc.urnResource('content_to_publish_status')
export default class ContentToPublishStatusModel extends AbstractContentToPublishStatusModel {}
